import { BasicSceneOptions } from '@gift/basic-scene-core/BasicSceneOptions';
import { createOptionBindings } from '@gift/website-state/slices/sceneSlice';

const { createOptionSelector } = createOptionBindings<BasicSceneOptions>();

export const selectSceneWidth = createOptionSelector(o => o.width);
export const selectSceneHeight = createOptionSelector(o => o.height);
export const selectPrefabBackgroundAlpha = createOptionSelector(o => o.prefabBackgroundAlpha ?? 0.2);
export const selectPrefabPreviewMode = createOptionSelector(o => o.prefabPreviewMode);
export const selectPrefabColumnWidth = createOptionSelector(o => o.prefabColumnWidth ?? 'small');
export const selectPrefabHeading = createOptionSelector(o => o.prefabHeading ?? 'layouts');